export default {
      id: "ar_signalement-usage",
      viewBox: "0 0 65 50",
      url: "../dist/images/" + "sprite.svg#ar_signalement-usage",
      toString: function () {
        return this.url;
      }
    }